import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

import { useIsFeatureEnabled } from "#app/featureToggle";
import { enabledOptimizationsQuery } from "#modules/optimizations/infra/enabledOptimizations.query";
import { Features } from "#types/FeatureToggleTypes";
import {
  computeOptimizedMachineTimes,
  NO_OPTIMIZED_MACHINE_TIMES,
  OptimizedMachineTimes,
} from "shared";

export const useOptimizedMachineTimes = (
  quoteRequestId: string | null | undefined,
): OptimizedMachineTimes => {
  const enabledOptimizations = useIsFeatureEnabled(Features.COSTING_OPTIMIZATION);

  const { data } = useQuery({
    ...enabledOptimizationsQuery({ quoteRequestId: quoteRequestId ?? "" }),
    enabled: !!quoteRequestId && enabledOptimizations,
  });

  return useMemo(
    () => (data ? computeOptimizedMachineTimes(data) : NO_OPTIMIZED_MACHINE_TIMES),
    [data],
  );
};
